import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-44115c0e"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["span"]

import { ref, computed } from 'vue'
import { cloneDeep } from 'lodash'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: [
  'model',
  'before',
  'rules',
  'btnSpan',
  'border',
  'labelWidth',
  'resetFn',
  'formOptions',
],
  emits: ['fetchList'],
  setup(__props, { expose, emit: $emit }) {

const props = __props;

const formRef = ref()



const classes = computed(() => {
  return props.border ? 'border' : ''
})

const btnSpan = computed(() => {
  const num = Object.keys(props.model).length % 4
  return props.btnSpan ?? 24 - num * 6
})

const fetchList = async (resetFields?: boolean) => {
  if (resetFields) {
    formRef.value.resetFields()
    keepAliveData.value = {}
    if (props.resetFn) {
      props.resetFn()
      return
    }
  } else {
    if (props.before) {
      const before: any = props.before()
      if (before && before.then) {
        before.then((res: any) => {
          if (res !== false) {
            keepAliveData.value = cloneDeep(props.model)
            $emit('fetchList', {
              data: cloneDeep(props.model),
              reset: resetFields,
            })
          }
        })
        return
      } else if (before === false) {
        return
      }
    }
  }
  keepAliveData.value = cloneDeep(props.model)
  $emit('fetchList', {
    data: cloneDeep(props.model),
    reset: resetFields,
  })
}

// 用于缓存之前查询的字段
const keepAliveData: any = ref({})
const getKeepAliveData = () => {
  return keepAliveData.value
}

expose({
  getKeepAliveData,
  formRef,
  fetchList,
})

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["advanced-query-layout-wrapper", _unref(classes)])
  }, [
    _createVNode(_component_el_form, _mergeProps({
      ref_key: "formRef",
      ref: formRef,
      model: props.model,
      "label-position": "left",
      "hide-required-asterisk": "",
      rules: props.rules,
      "label-width": props.labelWidth || 82
    }, {
        ...props.formOptions,
      }), {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default"),
        _createElementVNode("div", {
          span: _unref(btnSpan),
          class: "col-btn"
        }, [
          _createVNode(_component_el_button, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (fetchList(false))),
            type: "primary"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('COMMON.btnSearch')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (fetchList(true))),
            plain: ""
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('COMMON.btnReset')), 1)
            ]),
            _: 1
          })
        ], 8, _hoisted_1)
      ]),
      _: 3
    }, 16, ["model", "rules", "label-width"])
  ], 2))
}
}

})